import React, {useState, useEffect,useMemo} from 'react';
import axios from 'axios';

const AvisoLegal = () => {
    //salvar log de navegação
    useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
        IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
        logTipo: "Navegação",
        logModulo: "Política de Privacidade - Aviso Legal",
        logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
        logCriadoEm: new Date().toISOString(),
        logCodigoGUID: crypto.randomUUID()
    };
    axios                    
        .post(process.env.REACT_APP_API_URL 
            + '/routes.php?metodo=novoLog', 
            log, {
                headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            //console.log(response.data[0].mensagem);
        })
        .catch(error => {
            console.error('Erro ao enviar log:', error);
        });
    }, []);

    return (
        <div style={{ paddingBottom: '140px' }}>
      <main>
        <div>
          <div className='headerMain'>
            <label className='labelTitulo' ><h2>Política de Privacidade - Aviso Legal</h2></label>
          </div>
        </div>
        <div className='d-flex w100 flex-column flex-md-row justify-content-center align-items-start gap-4'>
        <div className='boxCenter'>
            <br />
            <p><b><h3>Bem-vindo ao site da Associação de Motociclistas Brasil Extremos (MGBE). 
                Este aviso legal tem como objetivo informar os usuários sobre os termos e condições de uso deste site, 
                bem como as políticas de privacidade e direitos autorais relacionados ao conteúdo disponível aqui.</h3></b></p>
            
            <p className='mt2'>O conteúdo deste site é protegido por direitos autorais e é de propriedade da Associação de Motociclistas Brasil Extremos (MGBE).</p>
            <p>O uso não autorizado do conteúdo, incluindo reprodução, distribuição ou modificação, é estritamente proibido sem a permissão expressa do MGBE. </p>
            <p>O MGBE se reserva o direito de modificar, atualizar ou remover qualquer conteúdo deste site a qualquer momento, sem aviso prévio. </p>
            <p>O MGBE não garante a precisão, integridade ou atualidade das informações fornecidas neste site.</p>
            
            <p className='mt2'>O MGBE não se responsabiliza por quaisquer danos ou perdas decorrentes do uso ou da incapacidade de usar este site, incluindo, mas não se limitando a, danos diretos, indiretos, incidentais, punitivos e consequenciais.</p>
            <p>O MGBE pode conter links para sites de terceiros, e não se responsabiliza pelo conteúdo ou práticas de privacidade desses sites de terceiros. O acesso a esses sites é por sua conta e risco.</p>
            
            <p className='mt2'>O MGBE se reserva o direito de alterar este aviso legal a qualquer momento. </p>
            <p>Recomendamos que você revise este aviso legal periodicamente para estar ciente de quaisquer alterações. </p>
            <p>O uso continuado deste site após a publicação de alterações a este aviso legal constitui aceitação dessas alterações.</p>
            <p>O uso deste site é regido pelas leis do Brasil. Qualquer disputa relacionada a este site será resolvida exclusivamente no território brasileiro.</p>
            
            <p className='mt2'>Esse site utiliza cookies para melhorar a experiência do usuário. Ao continuar a navegar no site, você concorda com o uso de cookies.</p>
            <p>Os cookies são pequenos arquivos de texto que são armazenados no seu dispositivo quando você visita um site. Eles são usados para lembrar suas preferências, melhorar a funcionalidade do site e fornecer análises sobre o uso do site.</p>
            <p>Você pode configurar seu navegador para recusar cookies ou para alertá-lo quando os cookies estiverem sendo enviados. No entanto, se você desativar os cookies, algumas partes deste site podem não funcionar corretamente.</p>
            <p>Para obter mais informações sobre como usamos cookies e como você pode gerenciar suas preferências de cookies, consulte nossa Política de Privacidade.</p>
            
            <p className='mt2'><b>Política de Privacidade</b></p>
            
            <p className='mt1'>O MGBE valoriza a privacidade dos usuários deste site e se compromete a proteger as informações pessoais que você compartilha conosco. Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações pessoais.</p>
            <p className='mt2'><b>Coleta de Informações</b></p>
            <p>Coletamos informações pessoais que você nos fornece voluntariamente ao usar este site, como seu nome, endereço de e-mail e outras informações de contato. Também podemos coletar informações sobre sua navegação no site, como páginas visitadas e tempo gasto em cada página, por meio do uso de cookies e tecnologias semelhantes.</p>
            <p className='mt2'><b>Uso das Informações</b></p>
            <p>Usamos as informações pessoais que coletamos para fornecer e melhorar nossos serviços, responder a suas perguntas e solicitações, enviar comunicações relacionadas ao site e personalizar sua experiência de navegação. Não compartilhamos suas informações pessoais com terceiros sem o seu consentimento, exceto quando exigido por lei ou para proteger nossos direitos.</p>
            <p className='mt2'><b>Armazenamento e Proteção das Informações</b></p>
            <p>Armazenamos suas informações pessoais em servidores seguros e adotamos medidas de segurança para proteger suas informações contra acesso não autorizado, alteração, divulgação ou destruição. No entanto, nenhum método de transmissão pela internet ou armazenamento eletrônico é 100% seguro, e não podemos garantir a segurança absoluta de suas informações.</p>
            <p className='mt2'><b>Seus Direitos</b></p>
            <p>Você tem o direito de acessar, corrigir ou excluir suas informações pessoais que coletamos. Você também pode optar por não receber comunicações de marketing nossas a qualquer momento. Para exercer esses direitos, entre em contato conosco através do e-mail: <a href="mailto:contato@brasilextremos.com.br" style={{ color: 'inherit', textDecoration: 'none', fontStyle: 'italic', fontSize: '0.9em' }}>contato@brasilextremos.com.br</a>.</p>
            
            <p className='mt2'><b>Se você não concorda com os termos deste aviso legal, por favor, não use este site.</b></p>
            <p className='mt1'><b>Ao acessar ou navegar neste site, você concorda com nossa Política de Privacidade e com os termos deste aviso legal.</b></p>
            <br />
            <p className='mt2'>Se você tiver alguma dúvida ou sugestão sobre este aviso legal, entre em contato conosco através do e-mail: <a href="mailto:contato@brasilextremos.com.br" style={{ color: 'inherit', textDecoration: 'none', fontStyle: 'italic', fontSize: '0.9em' }} >contato@brasilextremos.com.br</a>.</p>
            <p><b>Última atualização: 12 de junho de 2026</b></p>
        </div>
        </div>
        </main>
        </div>
    );
};

export default AvisoLegal;